export const BOARD_SIZE = 10;

export const SHIP_LENGTHS = [4, 3, 3, 2, 2, 2, 1, 1, 1, 1] as const;
